import { useSelector } from "react-redux";
import { UserRolesList } from "../../../components/UserRole/UserRolesList";
import { selectUserRoles } from "../../../store/userShow/selectors/selectUserRoles";
export const RolesList: React.FC = () => {
  const userRoles = useSelector(selectUserRoles);
  return <UserRolesList userRoles={userRoles} />;
};
